export default {
	gsiClientUrl: 'https://accounts.google.com/gsi/client',
	oauthUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
	scopes: 'email profile openid'
};
